<template>
  <nav class="menu">
    <!--    container-fluid-->
    <div
      class="
        max-w-full
        px-4
        flex
        relative
        justify-between
        py-3
        border-t border-solid border-gray-light
      "
    >
      <div class="menu-wrapper">
        <div
          class="menu-all"
          @mouseover="hover = true"
          @mouseleave="hover = false"
        >
          <div class="menu-all__content">
            <AppIcon
              name="format-list-bulleted"
              size="medium"
              color="text-gray-medium"
            />
            <span class="menu-all__label">
              {{ $t("menu.all_categories") }}
            </span>
          </div>
          <div class="menu-mega" :class="{ open }">
            <div class="menu-mega__wrapper">
              <div class="menu-mega__right">
                <ul>
                  <li
                    v-for="(item, index) in course_groups"
                    :key="`course_groups-${index}`"
                    class="ml-8"
                    @mouseover="getCourseById({ item })"
                  >
                    <a
                      :href="$routeName.teacher_list_absolute($config, joinParams(selected_group_active.link_parameters))"
                    >
                      {{ item.name }}
                    </a>
                  </li>
                </ul>
              </div>

              <div v-if="!loading" class="menu-mega__left">
                <div class="menu-mega__left_all">
                  <a
                    :href="$routeName.teacher_list_absolute($config, joinParams(selected_group_active.link_parameters))"
                  >
                    <span>همه دروس {{ selected_group_active.name }}</span>
                    <AppIcon name="chevron-left" />
                  </a>
                </div>
                <div class="menu-mega__left_list">
                  <ul
                    v-for="(item, index) in selected_list"
                    :key="`selected_group_courses-${index}`"
                    class="menu-mega__left__ul"
                  >
                    <li>
                      <a
                        :href="$routeName.teacher_list_absolute($config, joinParams(item.link_parameters))"
                        class="title"
                      >
                        <span>{{ item.name }}</span>
                        <AppIcon name="chevron-left" />
                      </a>
                    </li>
                    <li v-for="(child, j) in item.children" :key="`child-${j}`">
                      <a
                        :href="$routeName.teacher_list_absolute($config, joinParams(child.link_parameters))"
                      >
                        <span>{{ child.name }}</span>
                      </a>
                    </li>
                    <li v-if="item.has_more_children">
                      <a
                        :href="$routeName.teacher_list_absolute($config, joinParams(item.link_parameters))"
                        class="justify-start"
                      >
                        <p class="pl-2 text-xs text-blue-primary">
                          {{ $t("see_more_courses") }}
                        </p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <client-only>
                <div v-if="loading" class="menu-mega__left">
                  <div class="menu-mega__left_all">
                    <div class="animate-pulse">
                      <span
                        class="py-1 px-20 rounded inline-block bg-blue-light"
                      />
                      <AppIcon name="chevron-left" color="text-blue-light" />
                    </div>
                  </div>
                  <div class="menu-mega__left_list">
                    <ul
                      v-for="item in 10"
                      :key="item"
                      class="menu-mega__left__ul"
                    >
                      <li class="animate-pulse">
                        <div class="title">
                          <span
                            class="
                              py-1
                              px-16
                              rounded
                              inline-block
                              bg-blue-light
                            "
                          />
                          <AppIcon
                            name="chevron-left"
                            color="text-blue-light"
                          />
                        </div>
                      </li>
                      <!--eslint-disable-next-line vue/no-template-shadow-->
                      <li v-for="child in 4" :key="child" class="animate-pulse">
                        <div>
                          <span
                            class="
                              py-1
                              px-10
                              rounded
                              inline-block
                              bg-blue-light
                            "
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </client-only>
            </div>
          </div>
        </div>
        <div class="menu-mega__overlay" :class="{ open }" />
        <div class="menu-quick-list">
          <ul class="menu-quick-list__ul">
            <li
              v-for="(item, index) in important_course"
              :key="`important_course-${index}`"
              class="menu-quick-list__li"
            >
              <a
                :href="$routeName.teacher_list_absolute($config, joinParams(item.link_parameters))"
                class="menu-quick-list__a"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="2xl:w-max-[200px] relative">
        <AppInput
          v-model="search"
          :placeholder="$t('filter.input')"
          size="sm"
          :is-hidden-error="true"
          :loading="isLoading"
          @input="isTyping = true"
          @focus="showList"
          @click="showList"
        >
          <template #icon-left>
            <AppIcon
              v-if="!isListOpen"
              name="magnify"
              class="ml-2"
              color="text-gray-medium"
            />
            <AppIcon
              v-if="isListOpen"
              name="close"
              class="ml-2 cursor-pointer"
              color="text-gray-medium"
              @click="closeSearch"
            />
          </template>
        </AppInput>
        <div
          v-if="isListOpen"
          class="
            absolute
            inset-x-0
            top-full
            bg-white
            rounded-b
            z-50
            shadow-lg
            max-h-[400px]
            overflow-auto
          "
        >
          <SearchBoxList
            :query="search"
            :courses="courses"
            :teachers="teachers"
            :loading="isLoading"
            @closeList="closeSearch"
          />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import filter from '@mixins/filter.js'
import AppInput from '@library/element/input'
import AppIcon from '@library/element/icon'
import SearchBoxList from '@library/element/dropdown/dropdown-search/search-box'
import search from '@mixins/search'

export default {
  name: 'HeaderCategoriesDesktop',
  components: { AppIcon, SearchBoxList, AppInput },
  mixins: [filter, search],
  data () {
    return {
      loading: false,
      hover: false,
      open: false
    }
  },
  computed: {
    ...mapState('navbar', {
      important_course: state => state.important_course,
      course_groups: state => state.course_groups,
      selected_group_list: state => state.selected_group_list
    }),
    ...mapGetters({ selected_group_active: 'navbar/selected_group_active' }),
    selected_list () {
      return this.selected_group_list[
        this.selected_group_active.course_group_id
      ]
    }
  },
  watch: {
    hover (val) {
      this.open = !!val
      if (!val) {
        this.$store.dispatch('navbar/getCourse', {
          course_group_id: null
        })
      }
    },
    $route () {
      this.hover = false
    }
  },
  methods: {
    async getCourseById ({ item }) {
      try {
        const reqList = this.selected_group_list[item.course_group_id]
        if (reqList?.length) {
          this.$store.dispatch('navbar/setSelectedCourse', {
            course_group_id: item.course_group_id
          })
          return
        }
        this.loading = true
        await this.$store.dispatch('navbar/getCourse', {
          course_group_id: item.course_group_id
        })
        this.loading = false
      } catch (error) {
        this.$logger.captureException({ error })
      }
    }
  }
}
</script>

<style lang="scss">
.menu {
  @apply px-1;
  &-wrapper {
    @apply flex place-items-center relative z-10;
  }

  &-all {
    @apply w-40  cursor-pointer;
    &__content {
      @apply p-2 relative w-full inline-flex place-items-center;
      @include shapeBorder($color: gray-light);
    }

    /*&:hover {
      .menu-mega {
        @apply flex;
      }
      + .menu-mega__overlay {
        @apply block;
      }
    }*/
    &__label {
      @apply font-medium text-sm mr-2;
    }
  }

  &-quick-list {
    @apply mr-8 xl:mr-10;
    &__ul {
      @apply flex place-items-center;
    }

    &__a {
      @apply text-xs xl:text-sm font-medium hover:text-blue-primary transition-colors px-4 xl:px-7 text-gray-medium;
    }
  }

  &-mega {
    @apply absolute right-0 left-0 top-full hidden;
    &.open {
      @apply flex;
      width: 97vw;
    }

    &__overlay {
      @apply bg-gray-light  -z-1 top-full -right-5 -left-5 absolute hidden;
      height: calc(100vh - 106px);
      width: 100vw;

      &.open {
        @apply block;
      }
    }

    &__wrapper {
      @apply flex mt-1 rounded shadow  w-full;
    }

    &__right {
      @apply bg-blue-background w-40 min-w-40 rounded-br rounded-tr border-l border-gray-light;
      ul {
        li {
          @apply text-gray-main hover:text-blue-primary  transition-colors;
          a {
            @apply px-4 py-2 block text-sm;
          }
        }
      }
    }

    &__left {
      @apply bg-white rounded-bl rounded-tl w-full flex flex-col flex pb-3;
      &_all {
        @apply w-full px-4 py-3;
        a,
        div {
          @apply flex items-center;
          span {
            @apply font-medium text-sm text-gray-main hover:text-blue-primary transition-colors;
          }

          svg {
            @apply mr-4;
          }
        }
      }

      &_list {
        @apply grid grid-cols-5;
        ul {
          li {
            a,
            div {
              @apply text-gray-main px-4 py-2 flex place-items-center;
              span {
                @apply text-gray-medium text-sm hover:text-blue-hover transition-colors;
              }

              svg {
                @apply mr-4;
              }

              &.title {
                span {
                  @apply font-medium  text-gray-main hover:text-blue-hover;
                }
              }
            }
          }
        }
      }
    }
  }
  .nuxt-link-active span,
  .nuxt-link-active {
    @apply text-blue-primary;
  }
}
</style>
